module.exports = __webpack_public_path__ + "static/media/check-in.f6089d54.svg";